/**
 * @module
 * @description Content Modules JavaScripts Init
 */

import accordion from './accordion';
import media from './media';

/**
 * @function init
 * @description Kick off this modules functions
 */

const init = () => {
	accordion();
	media();
};

export default init;
